import {
  IModelConnection,
  StandardViewId,
  ViewState,
} from "@itwin/core-frontend";
import { ViewSetup } from "../ViewSetup";

export default class ViewApi {
  /* Get the initial view for the widget*/
  public static getIsoView = async (
    imodel: IModelConnection
  ): Promise<ViewState> => {
    const viewState = await ViewSetup.getDefaultView(imodel);

    if (viewState.is3d()) {
      // const displayStyle = viewState.getDisplayStyle3d();
      //displayStyle.changeBackgroundMapProps({ transparency: 1.0 });

      // Rotate the view to make the view clip look better.
      viewState.setStandardRotation(StandardViewId.RightIso);

      const range = viewState.computeFitRange();
      const aspect = ViewSetup.getAspectRatio();

      viewState.lookAtVolume(range, aspect);
    }

    return viewState;
  };
}
